import React from "react";
import LandingSimpleSection from "@insightfulscience/atomic-react/LandingElement/SimpleSection";
import Heading from "@insightfulscience/atomic-react/Heading";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import { arrayOf, shape, string } from "prop-types";
import AcademyToCLink from "./AcademyToCLink";

const AcademyToC = ({ items }) => {
	return (
		<LandingSimpleSection bgColor="5--12" spacing={{ py: 2 }}>
			<Heading center size="l" sx={{ fontWeight: 300 }} spacing={{ my: 3 }}>
				Course Content
			</Heading>
			<Row center>
				<Col sm={12} lg={6} md={6}>
					{items.map((item, key) => {
						if (key % 2 === 0) {
							return (
								<AcademyToCLink title={item.title} slug={item.slug} key={items.indexOf(item)} />
							);
						}
						return null;
					})}
				</Col>
				<Col sm={12} md="shrink">
					{items.map((item, key) => {
						if (key % 2 !== 0) {
							return (
								<AcademyToCLink title={item.title} slug={item.slug} key={items.indexOf(item)} />
							);
						}
						return null;
					})}
				</Col>
			</Row>
		</LandingSimpleSection>
	);
};

AcademyToC.propTypes = {
	items: arrayOf(
		shape({
			title: string.isRequired,
			slug: string.isRequired,
		}),
	).isRequired,
};

export default AcademyToC;
